// ✅ Correct imports (relative to this file’s folder)
import HTML_Home from "./HTML_Home";
import HTML_Introduction from "./HTML_Introduction";
import HTML_Editors from "./HTML_Editors";
import HTML_Basic from "./HTML_Basic";
import HTML_Elements from "./HTML_Elements";
import HTML_Attributes from "./HTML_Attributes";
import HTML_Headings from "./HTML_Headings";
import HTML_Paragraphs from "./HTML_Paragraphs";
import HTML_Styles from "./HTML_Styles";
import HTML_Formatting from "./HTML_Formatting";
import HTML_Quotations from "./HTML_Quotations";
import HTML_Comments from "./HTML_Comments";
import HTML_Colors from "./HTML_Colors";
import HTML_RGB from "./HTML_RGB";
import HTML_HEX from "./HTML_HEX";
import HTML_HSL from "./HTML_HSL";
import HTML_CSS from "./HTML_CSS";
import HTML_Links from "./HTML_Links";
import HTML_Links_Colors from "./HTML_Links_Colors";
import HTML_Links_Bookmarks from "./HTML_Links_Bookmarks";
import HTML_Images from "./HTML_Images";
import Images_Map from "./Images_Map";
import Background_Images from "./Background_Images";
import The_Picture_Element from "./The_Picture_Element";
import HTML_Favicon from "./HTML_Favicon";
import HTML_Page_Title from "./HTML_Page_Title";
import HTML_Tables from "./HTML_Tables";
import Table_Borders from "./Table_Borders";
import Table_Size from "./Table_Size";
import Table_Headers from "./Table_Headers";
import Padding_And_Spacing from "./Padding_And_Spacing";
import Colspan_And_Rowspan from "./Colspan_And_Rowspan";
import Table_Styling from "./Table_Styling";
import Table_Colgroup from "./Table_Colgroup";
import HTML_Lists from "./HTML_Lists";
import Ordered_Lists from "./Ordered_Lists";
import Other_Lists from "./Other_Lists";
import HTML_Block_Inline from "./HTML_Block_Inline";
import HTML_Div from "./HTML_Div";
import HTML_Classes from "./HTML_Classes";
import HTML_Id from "./HTML_Id";
import HTML_Iframes from "./HTML_Iframes";
import HTML_JavaScript from "./HTML_JavaScript";
import HTML_File_Paths from "./HTML_File_Paths";
import HTML_Head from "./HTML_Head";
import HTML_Layout from "./HTML_Layout";
import HTML_Responsive from "./HTML_Responsive";
import HTML_Computercode from "./HTML_Computercode";
import HTML_Semantics from "./HTML_Semantics";
import HTML_Style_Guide from "./HTML_Style_Guide";
import HTML_Entities from "./HTML_Entities";
import HTML_Symbols from "./HTML_Symbols";
import HTML_Emojis from "./HTML_Emojis";
import HTML_Charsets from "./HTML_Charsets";
import HTML_URL_Encode from "./HTML_URL_Encode";
import HTML_vs_XHTML from "./HTML_vs_XHTML";

import HTML_Forms from "./HTML_Forms";
import HTML_Form_Attributes from "./HTML_Form_Attributes";
import HTML_Form_Elements from "./HTML_Form_Elements";
import HTML_Input_Types from "./HTML_Input_Types";
import HTML_Input_Attributes from "./HTML_Input_Attributes";
import Input_Form_Attributes from "./Input_Form_Attributes";

import HTML_Canvas from "./HTML_Canvas";
import HTML_SVG from "./HTML_SVG";

import HTML_Media from "./HTML_Media";
import HTML_Video from "./HTML_Video";
import HTML_Audio from "./HTML_Audio";
import HTML_Plug_ins from "./HTML_Plug_ins";
import HTML_YouTube from "./HTML_YouTube";

import HTML_Web_APIs from "./HTML_Web_APIs";
import HTML_Geolocation from "./HTML_Geolocation";
import HTML_Drag_and_Drop from "./HTML_Drag_and_Drop";
import HTML_Web_Storage from "./HTML_Web_Storage";
import HTML_Web_Workers from "./HTML_Web_Workers";
import HTML_SSE from "./HTML_SSE";

import HTML_Examples from "./HTML_Examples";
import HTML_Editor from "./HTML_Editor";
import HTML_Quiz from "./HTML_Quiz";
import HTML_Exercises from "./HTML_Exercises";
import HTML_Website from "./HTML_Website";
import HTML_Syllabus from "./HTML_Syllabus";
import HTML_Study_Plan from "./HTML_Study_Plan";
import HTML_Interview_Prep from "./HTML_Interview_Prep";
import HTML_Bootcamp from "./HTML_Bootcamp";
import HTML_Certificate from "./HTML_Certificate";
import HTML_Summary from "./HTML_Summary";
import HTML_Accessibility from "./HTML_Accessibility";

import HTML_Tag_List from "./HTML_Tag_List";
import HTML_Global_Attributes from "./HTML_Global_Attributes";
import HTML_Browser_Support from "./HTML_Browser_Support";
import HTML_Events from "./HTML_Events";
import HTML_Audio_Video from "./HTML_Audio_Video";
import HTML_Doctypes from "./HTML_Doctypes";
import HTML_Character_Sets from "./HTML_Character_Sets";
import HTML_Lang_Codes from "./HTML_Lang_Codes";
import HTTP_Messages from "./HTTP_Messages";
import HTTP_Methods from "./HTTP_Methods";
// import PX_to_EM_Converter from "./PX_to_EM_Converter";
import Keyboard_Shortcuts from "./Keyboard_Shortcuts";
import PX_to_EM_Converter from "./PX_toEM_Converter";

// ✅ Map components
const AllHtmlComponents = {
  "<HTML_Home />": HTML_Home,
  "<HTML_Introduction />": HTML_Introduction,
  "<HTML_Editors />": HTML_Editors,
  "<HTML_Basic />": HTML_Basic,
  "<HTML_Elements />": HTML_Elements,
  "<HTML_Attributes />": HTML_Attributes,
  "<HTML_Headings />": HTML_Headings,
  "<HTML_Paragraphs />": HTML_Paragraphs,
  "<HTML_Styles />": HTML_Styles,
  "<HTML_Formatting />": HTML_Formatting,
  "<HTML_Quotations />": HTML_Quotations,
  "<HTML_Comments />": HTML_Comments,
  "<HTML_Colors />": HTML_Colors,
  "<HTML_RGB />": HTML_RGB,
  "<HTML_HEX />": HTML_HEX,
  "<HTML_HSL />": HTML_HSL,
  "<HTML_CSS />": HTML_CSS,
  "<HTML_Links />": HTML_Links,
  "<HTML_Links_Colors />": HTML_Links_Colors,
  "<HTML_Links_Bookmarks />": HTML_Links_Bookmarks,
  "<HTML_Images />": HTML_Images,
  "<Images_Map />": Images_Map,
  "<Background_Images />": Background_Images,
  "<The_Picture_Element />": The_Picture_Element,
  "<HTML_Favicon />": HTML_Favicon,
  "<HTML_Page_Title />": HTML_Page_Title,
  "<HTML_Tables />": HTML_Tables,
  "<Table_Borders />": Table_Borders,
  "<Table_Size />": Table_Size,
  "<Table_Headers />": Table_Headers,
  "<Padding_And_Spacing />": Padding_And_Spacing,
  "<Colspan_And_Rowspan />": Colspan_And_Rowspan,
  "<Table_Styling />": Table_Styling,
  "<Table_Colgroup />": Table_Colgroup,
  "<HTML_Lists />": HTML_Lists,
  "<Ordered_Lists />": Ordered_Lists,
  "<Other_Lists />": Other_Lists,
  "<HTML_Block_Inline />": HTML_Block_Inline,
  "<HTML_Div />": HTML_Div,
  "<HTML_Classes />": HTML_Classes,
  "<HTML_Id />": HTML_Id,
  "<HTML_Iframes />": HTML_Iframes,
  "<HTML_JavaScript />": HTML_JavaScript,
  "<HTML_File_Paths />": HTML_File_Paths,
  "<HTML_Head />": HTML_Head,
  "<HTML_Layout />": HTML_Layout,
  "<HTML_Responsive />": HTML_Responsive,
  "<HTML_Computercode />": HTML_Computercode,
  "<HTML_Semantics />": HTML_Semantics,
  "<HTML_Style_Guide />": HTML_Style_Guide,
  "<HTML_Entities />": HTML_Entities,
  "<HTML_Symbols />": HTML_Symbols,
  "<HTML_Emojis />": HTML_Emojis,
  "<HTML_Charsets />": HTML_Charsets,
  "<HTML_URL_Encode />": HTML_URL_Encode,
  "<HTML_vs_XHTML />": HTML_vs_XHTML,

  "<HTML_Forms />": HTML_Forms,
  "<HTML_Form_Attributes />": HTML_Form_Attributes,
  "<HTML_Form_Elements />": HTML_Form_Elements,
  "<HTML_Input_Types />": HTML_Input_Types,
  "<HTML_Input_Attributes />": HTML_Input_Attributes,
  "<Input_Form_Attributes />": Input_Form_Attributes,

  "<HTML_Canvas />": HTML_Canvas,
  "<HTML_SVG />": HTML_SVG,

  "<HTML_Media />": HTML_Media,
  "<HTML_Video />": HTML_Video,
  "<HTML_Audio />": HTML_Audio,
  "<HTML_Plug_ins />": HTML_Plug_ins,
  "<HTML_YouTube />": HTML_YouTube,

  "<HTML_Web_APIs />": HTML_Web_APIs,
  "<HTML_Geolocation />": HTML_Geolocation,
  "<HTML_Drag_and_Drop />": HTML_Drag_and_Drop,
  "<HTML_Web_Storage />": HTML_Web_Storage,
  "<HTML_Web_Workers />": HTML_Web_Workers,
  "<HTML_SSE />": HTML_SSE,

  "<HTML_Examples />": HTML_Examples,
  "<HTML_Editor />": HTML_Editor,
  "<HTML_Quiz />": HTML_Quiz,
  "<HTML_Exercises />": HTML_Exercises,
  "<HTML_Website />": HTML_Website,
  "<HTML_Syllabus />": HTML_Syllabus,
  "<HTML_Study_Plan />": HTML_Study_Plan,
  "<HTML_Interview_Prep />": HTML_Interview_Prep,
  "<HTML_Bootcamp />": HTML_Bootcamp,
  "<HTML_Certificate />": HTML_Certificate,
  "<HTML_Summary />": HTML_Summary,
  "<HTML_Accessibility />": HTML_Accessibility,

  "<HTML_Tag_List />": HTML_Tag_List,
  "<HTML_Global_Attributes />": HTML_Global_Attributes,
  "<HTML_Browser_Support />": HTML_Browser_Support,
  "<HTML_Events />": HTML_Events,
  "<HTML_Audio_Video />": HTML_Audio_Video,
  "<HTML_Doctypes />": HTML_Doctypes,
  "<HTML_Character_Sets />": HTML_Character_Sets,
  "<HTML_Lang_Codes />": HTML_Lang_Codes,
  "<HTTP_Messages />": HTTP_Messages,
  "<HTTP_Methods />": HTTP_Methods,
  "<PX_to_EM_Converter />": PX_to_EM_Converter,
  "<Keyboard_Shortcuts />": Keyboard_Shortcuts,
};

export default AllHtmlComponents;
